// Module
var code = "<all-receipts ng-if=$ctrl.request request=$ctrl.request handle-click=\"$ctrl.handleReceiptClick({ location })\" location=$ctrl.location></all-receipts>";
// Exports
module.exports = code;